import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const mapIdSelector = (state: AppState) => state.map.mapId;
export const useMapIdSelector = () => useSelector<null | number>(mapIdSelector);
